import './LandingBlogPosts.scss';

import { Post } from '@travelwin/cms/types';
import { ButtonV2 } from '@travelwin/core';
import { useTranslation } from 'react-i18next';

import { BlogPostCardGrid } from '@/components/BlogPostCardGrid';
import { Link } from '@/components/Link';

const className = 'c-LandingBlogPosts';

export const LandingBlogPosts = ({
  posts,
  title,
  subtitle,
}: {
  posts: Post[];
  title: string;
  subtitle?: string;
}) => {
  const { t } = useTranslation();

  if (posts.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      <div className={`${className}__header`}>
        <div className={`${className}__title`}>{title}</div>
        {subtitle ? (
          <div className={`${className}__subtitle`}>{subtitle}</div>
        ) : null}
      </div>
      <BlogPostCardGrid posts={posts} />
      <div className={`${className}__footer-button`}>
        <ButtonV2 asChild variant="primary" size="large" fluid={{ sm: true }}>
          <Link to="/news">{t('landing.see_all_posts', 'See More')}</Link>
        </ButtonV2>
      </div>
    </div>
  );
};
